// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5687) return "static/chunks/5687.6b1308168c634547.js";
	// return url for filenames based on template
	return "static/chunks/" + {"4390":"d648eb28","9690":"8cc6faea"}[chunkId] + "-" + {"4390":"c326c40aa285851c","9690":"d272f77a9500d034"}[chunkId] + ".js";
};